export const ActionTypes = {
  FETCH_ALL: 'services/groups/fetch_all',
  FETCH_ALL_BY_FACTORY_ID: 'services/groups/fetch_all_by_factory_id',
  SET_ALL_BY_FACTORY_ID: 'services/groups/set_all_by_factory_id',
  FETCH_ALL_SUCCESS: 'services/groups/fetch_all_success',
  SET_LOADER_STATUS: 'services/groups/set_loader_status',
  SET_ALL: 'services/groups/set_all',
  ADD_OR_UPDATE_GROUP: 'services/group/add_or_update_group',
  DELETE_GROUP: 'services/group/delete_group',
};

const fetchAll = ({ groupParams }) => ({
  groupParams,
  type: ActionTypes.FETCH_ALL,
});

const fetchAllFactoryGroups = ({ factoryId }) => ({
  factoryId,
  type: ActionTypes.FETCH_ALL_BY_FACTORY_ID,
});

const setAllFactoryGroups = ({ factoryGroups }) => ({
  factoryGroups,
  type: ActionTypes.SET_ALL_BY_FACTORY_ID,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const setAll = ({ allGroup }) => ({
  allGroup,
  type: ActionTypes.SET_ALL,
});

const addorUpdateGroup = ({ groupData, actionName, groupParams }) => ({
  groupData,
  actionName,
  groupParams,
  type: ActionTypes.ADD_OR_UPDATE_GROUP,
});

const deleteGroup = ({ id, groupParams }) => ({
  id,
  groupParams,
  type: ActionTypes.DELETE_GROUP,
});

export default {
  fetchAll,
  fetchAllFactoryGroups,
  setAllFactoryGroups,
  setAll,
  setLoader,
  addorUpdateGroup,
  deleteGroup,
};
